import React, { useState, useRef, useEffect } from "react";
import "./ServiceBookingForm.css";

// ✅ NEW: API base for saving inquiries to database
const API_BASE = "https://www.thehexaplay.com/api";

/* ---- Inline SVG Icons ---- */
const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.6a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.6a16 16 0 0 0 6.01 6.01l.97-.97a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);
const ClipboardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
  </svg>
);
const CalendarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const MapPinIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const MessageIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);
const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const CallIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.6a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.6a16 16 0 0 0 6.01 6.01l.97-.97a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);
const ChevronLeftIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRightIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

/* ---- Services List ---- */
const SERVICES = [
  "Baby Shower",
  "Birthday",
  "Corporate Events",
  "Engagement",
  "Latest Decorations",
  "Mehandi",
  "Puberty Function",
  "Reception",
  "Wedding"
];

/* ================= COMPONENT ================= */
const ServiceBookingForm = () => {
  const today = new Date().toISOString().split("T")[0];

  const [form, setForm] = useState({
    name: "",
    mobile: "",
    service: "",
    date: "",
    location: "",
    message: ""
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  /* Calendar State */
  const [showCalendar, setShowCalendar] = useState(false);
  const [viewMonth, setViewMonth] = useState(new Date());
  const calendarRef = useRef(null);

  /* Lock body scroll & close on outside click */
  useEffect(() => {
    document.body.style.overflow = showCalendar ? "hidden" : "";
    const handleOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };
    if (showCalendar) {
      document.addEventListener("mousedown", handleOutside);
      document.addEventListener("touchstart", handleOutside);
    }
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, [showCalendar]);

  /* ---- Handlers ---- */
  const handleNameChange = (e) => {
    const val = e.target.value.replace(/[^a-zA-Z\s]/g, "");
    setForm((f) => ({ ...f, name: val }));
    if (errors.name) setErrors((er) => ({ ...er, name: "" }));
  };

  const handleMobileChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 10);
    setForm((f) => ({ ...f, mobile: val }));
    if (errors.mobile) setErrors((er) => ({ ...er, mobile: "" }));
  };

  const handleChange = (field) => (e) => {
    setForm((f) => ({ ...f, [field]: e.target.value }));
    if (errors[field]) setErrors((er) => ({ ...er, [field]: "" }));
  };

  /* ---- Calendar Logic ---- */
  const openCalendar = () => {
    const base = form.date ? new Date(form.date + "T00:00:00") : new Date();
    setViewMonth(new Date(base.getFullYear(), base.getMonth(), 1));
    setShowCalendar(true);
  };

  const prevMonth = (e) => {
    e.stopPropagation();
    setViewMonth(new Date(viewMonth.getFullYear(), viewMonth.getMonth() - 1, 1));
  };

  const nextMonth = (e) => {
    e.stopPropagation();
    setViewMonth(new Date(viewMonth.getFullYear(), viewMonth.getMonth() + 1, 1));
  };

  const selectDate = (day) => {
    const y = viewMonth.getFullYear();
    const m = String(viewMonth.getMonth() + 1).padStart(2, "0");
    const d = String(day).padStart(2, "0");
    const dateStr = `${y}-${m}-${d}`;
    setForm((f) => ({ ...f, date: dateStr }));
    if (errors.date) setErrors((er) => ({ ...er, date: "" }));
    setShowCalendar(false);
  };

  const getDaysInMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  const getFirstDay = (date) => new Date(date.getFullYear(), date.getMonth(), 1).getDay();

  const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const dayNames = ["Su","Mo","Tu","We","Th","Fr","Sa"];

  const daysInMonth = getDaysInMonth(viewMonth);
  const firstDay = getFirstDay(viewMonth);
  const calendarDays = [];
  for (let i = 0; i < firstDay; i++) calendarDays.push(null);
  for (let d = 1; d <= daysInMonth; d++) calendarDays.push(d);

  /* ---- Validation ---- */
  const validate = () => {
    const err = {};
    if (!form.name.trim()) err.name = "Name is required";
    if (!form.mobile.trim()) err.mobile = "Mobile number is required";
    else if (!/^[6-9]\d{9}$/.test(form.mobile)) err.mobile = "Enter a valid 10-digit mobile number";
    if (!form.service) err.service = "Please select a service";
    if (!form.date) err.date = "Please select a date";
    if (!form.location.trim()) err.location = "Location is required";
    return err;
  };

  /* ---- Format date for display & WhatsApp ---- */
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  /* ---- ✅ UPDATED SUBMIT — Saves to DB FIRST, then opens WhatsApp ---- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSubmitted(false);
      return;
    }

    setErrors({});
    setSubmitted(true);

    // 1. Save to MongoDB (non-blocking — won't break flow if it fails)
    try {
      await fetch(`${API_BASE}/inquiries`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "event",
          name: form.name,
          mobile: form.mobile,
          whatsapp: form.mobile,
          service: form.service,
          date: formatDate(form.date),
          location: form.location,
          message: form.message,
        }),
      });
      console.log("✅ Event inquiry saved to DB");
    } catch (err) {
      console.warn("⚠️ Could not save event inquiry:", err);
    }

    // 2. Open WhatsApp
    const whatsappNumber = "919087775659";
    const text =
      `Hello HexaPlay Team! 👋%0A%0A` +
      `*🎉 New Service Booking*%0A%0A` +
      `👤 *Name:* ${form.name}%0A` +
      `📞 *Mobile:* +91 ${form.mobile}%0A` +
      `🎊 *Service:* ${form.service}%0A` +
      `📅 *Event Date:* ${formatDate(form.date)}%0A` +
      `📍 *Location:* ${form.location}` +
      (form.message ? `%0A💬 *Message:* ${encodeURIComponent(form.message)}` : "");

    const url = `https://wa.me/${whatsappNumber}?text=${text}`;
    window.open(url, "_blank");

    setForm({ name: "", mobile: "", service: "", date: "", location: "", message: "" });
  };

  return (
    <section className="sbf-hero-section">
      <div className="sbf-hero-content">
        {/* Mobile: title above card */}
        <div className="sbf-hero-title-block">
          <h1 className="sbf-hero-heading">Book Your Event Service</h1>
          <p className="sbf-hero-sub">
            Let us make your celebration truly unforgettable
          </p>
        </div>

        {/* Booking Card */}
        <div className="sbf-booking-card">
          {/* Desktop: title inside card */}
          <div className="sbf-card-title-desktop">
            <h2>Book Your Event Service</h2>
            <p className="sbf-booking-sub">
              Let us make your celebration truly unforgettable
            </p>
          </div>

          {submitted && (
            <div className="sbf-success-message">
              ✅ Redirecting to WhatsApp... Please press Send to confirm your booking!
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            {/* Name */}
            <div className={`sbf-input-row ${errors.name ? "error" : ""}`}>
              <span className="sbf-input-icon-wrap"><UserIcon /></span>
              <span className="sbf-input-divider" />
              <input type="text" placeholder="Enter your full name" value={form.name} onChange={handleNameChange} maxLength="50" autoComplete="name" />
            </div>
            {errors.name && <div className="sbf-error-message show">{errors.name}</div>}

            {/* Mobile */}
            <div className={`sbf-input-row ${errors.mobile ? "error" : ""}`}>
              <span className="sbf-input-icon-wrap"><PhoneIcon /></span>
              <span className="sbf-input-divider" />
              <input type="tel" placeholder="Enter 10 digit mobile number" value={form.mobile} onChange={handleMobileChange} maxLength="10" inputMode="numeric" autoComplete="tel" />
            </div>
            {errors.mobile && <div className="sbf-error-message show">{errors.mobile}</div>}

            {/* Service Dropdown */}
            <div className={`sbf-input-row sbf-select-row ${errors.service ? "error" : ""}`}>
              <span className="sbf-input-icon-wrap"><ClipboardIcon /></span>
              <span className="sbf-input-divider" />
              <select value={form.service} onChange={handleChange("service")}>
                <option value="" disabled>Select a service</option>
                {SERVICES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
              <span className="sbf-select-chevron"><ChevronDownIcon /></span>
            </div>
            {errors.service && <div className="sbf-error-message show">{errors.service}</div>}

            {/* Date (Custom Calendar Trigger) */}
            <div className={`sbf-input-row sbf-date-row ${errors.date ? "error" : ""}`} onClick={openCalendar}>
              <span className="sbf-input-icon-wrap"><CalendarIcon /></span>
              <span className="sbf-input-divider" />
              <div className="sbf-date-display">
                {!form.date ? (
                  <span className="sbf-date-placeholder">Select Your Occasion Date</span>
                ) : (
                  <span className="sbf-date-value">{formatDate(form.date)}</span>
                )}
              </div>
            </div>
            {errors.date && <div className="sbf-error-message show">{errors.date}</div>}

            {/* Location */}
            <div className={`sbf-input-row ${errors.location ? "error" : ""}`}>
              <span className="sbf-input-icon-wrap"><MapPinIcon /></span>
              <span className="sbf-input-divider" />
              <input type="text" placeholder="Enter event location" value={form.location} onChange={handleChange("location")} maxLength="100" autoComplete="off" />
            </div>
            {errors.location && <div className="sbf-error-message show">{errors.location}</div>}

            {/* Message */}
            <div className="sbf-input-row sbf-textarea-row">
              <span className="sbf-input-icon-wrap sbf-textarea-icon"><MessageIcon /></span>
              <span className="sbf-input-divider sbf-textarea-divider" />
              <textarea rows="3" placeholder="Additional message (optional)" value={form.message} onChange={handleChange("message")} />
            </div>

            {/* Submit */}
            <button type="submit" className="sbf-book-btn">Submit Booking</button>

            {/* Call CTA */}
            <a href="tel:+919566137290" className="sbf-call-btn">
              <CallIcon />
              Book On Call
            </a>
          </form>
        </div>
      </div>

      {/* Custom Calendar Overlay */}
      {showCalendar && (
        <div className="sbf-calendar-overlay">
          <div className="sbf-calendar-card" ref={calendarRef} onClick={(e) => e.stopPropagation()}>
            <div className="sbf-calendar-header">
              <button type="button" className="sbf-cal-nav" onClick={prevMonth} aria-label="Previous month"><ChevronLeftIcon /></button>
              <span className="sbf-cal-month-title">{monthNames[viewMonth.getMonth()]} {viewMonth.getFullYear()}</span>
              <button type="button" className="sbf-cal-nav" onClick={nextMonth} aria-label="Next month"><ChevronRightIcon /></button>
            </div>

            <div className="sbf-cal-weekdays">
              {dayNames.map((d) => <div key={d} className="sbf-cal-weekday">{d}</div>)}
            </div>

            <div className="sbf-cal-days">
              {calendarDays.map((day, idx) => {
                if (!day) return <div key={`empty-${idx}`} className="sbf-cal-day sbf-cal-empty"></div>;
                const y = viewMonth.getFullYear();
                const m = String(viewMonth.getMonth() + 1).padStart(2, "0");
                const dStr = String(day).padStart(2, "0");
                const dateStr = `${y}-${m}-${dStr}`;
                const isPast = dateStr < today;
                const isToday = dateStr === today;
                const isSelected = dateStr === form.date;

                return (
                  <div
                    key={dateStr}
                    className={`sbf-cal-day${isPast ? " sbf-cal-past" : ""}${isToday ? " sbf-cal-today" : ""}${isSelected ? " sbf-cal-selected" : ""}`}
                    onClick={isPast ? undefined : () => selectDate(day)}
                  >
                    {day}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ServiceBookingForm;